export default {
	editorPanel: {
		minimizeTooltip: "réduire",
		readOnlySuffix: "(lecture seule)",
		featureModeTooltip: "Sélectionner et insérer/modifier des usinages pour filetages, lamages, etc.",
		measuringModeTooltip: "Mesurer la géométrie",
		weldModeTooltip: "Définir un cordon de soudure",
		weldModeDisabledTooltip:
			"Ce matériau ne peut actuellement pas être soudé. Vous trouverez les informations sur " +
			"les matériaux soudables sur blexon.com/werkstoffe",
		rollDirectionModeTooltip: "Définir le sens de laminage",
		switchTopSideTooltip: "Changer le côté supérieur",
		zoomToFit: "Ajuster à la vue",
		noValidationLabel: "Aucune validation",
	},
	errorDialog: {
		closeButton: "Fermer",
	},
	messagePanel: {
		noMessages: "Aucun message",
	},
	modePanel: {
		minimizeTooltip: "réduire",
		noModeSelected: "Aucun mode n'est actuellement sélectionné.",
	},
	sendToHelpdesk: {
		title: "Envoyer l'article au service d'assistance Blexon",
		introText:
			"Vous envoyez cet article au service d'assistance Blexon. Nous examinerons la cause des " +
			"messages d'erreur et la corrigerons si possible. Nous vous donnerons également " +
			"volontiers des indications sur la manière de modifier la construction afin que " +
			"l'article devienne réalisable. Ce service est gratuit.",
		notificationText:
			"Vous serez informé par e-mail dès que l'article aura été traité. La vérification " +
			"s'effectue généralement en quelques heures pendant les heures d'ouverture.",
		lockNotice:
			"Veuillez noter qu'après l'envoi, l'article ne pourra plus être modifié ni supprimé " +
			"jusqu'à ce qu'il soit validé par Blexon.",
		emailLabel: "E-mail pour les notifications concernant cet article",
		emailPlaceholder: "Saisissez l'adresse e-mail ici...",
		emailRequiredError: "L'adresse e-mail doit être indiquée.",
		emailInvalidError: "Ce n'est pas une adresse e-mail valide.",
		submitButton: "Envoyer et fermer",
		cancelButton: "Annuler",
	},
	unsavedChanges: {
		title: "Certaines modifications n'ont pas encore été enregistrées.",
		message: "Voulez-vous annuler les modifications ?",
		discardButton: "Annuler les modifications",
		cancelButton: "Non",
	},
	validationMessage: {
		showFeaturesTooltip: "Afficher les fonctionnalités dans le modèle",
		correctTooltip: "Corriger",
		learnMoreLink: "En savoir plus...",
		releaseCutsWarningTitle: "Créer une découpe de dégagement dans la zone de pliage",
		releaseCutsWarningText1:
			"La création des découpes de dégagement entraîne la perte des filetages, lamages, " +
			"collerettes extrudées et lamages pour vis à tête cylindrique existants, qui devront " +
			"ensuite être redéfinis.",
		releaseCutsWarningText2:
			"Nous recommandons de créer les découpes de dégagement dans la zone de pliage au tout " +
			"début de l'usinage.",
		createReleaseCutsButton: "Créer la découpe de dégagement",
		cancelButton: "Annuler",
	},
	cadView: {
		gizmoRight: "Droite",
		gizmoLeft: "Gauche",
		gizmoTop: "Haut",
		gizmoBottom: "Bas",
		gizmoFront: "Avant",
		gizmoBack: "Arrière",
	},
};
